import * as _ from 'lodash'
import { copyObject } from '../../../../utils'
import { InvoiceWorkerT } from '../../../../types/JobWorker'

export const prepareWorkerInvoice = (lineItems: Array<InvoiceWorkerT>, hourlyRate: number, jobDuration: number) => {
  const items = []
  lineItems.map((item) => {
    const cloneItem = copyObject(item)
    if (!item.isDirty) {
      const rate = _.isNumber(hourlyRate) ? parseFloat(`${hourlyRate}`) : 0
      const units = _.isNumber(jobDuration) ? parseFloat(`${jobDuration}`) : 0
      cloneItem.rate = rate
      cloneItem.units = units
      cloneItem.total = Number(rate) * Number(units)
    }
    items.push(cloneItem)
  })
  return items
}
